'use strict';

function fMenuToggle() {
    const oMenu = document.querySelector('.js-menu');
    const aMenuItems = [].slice.call(oMenu.querySelectorAll('.header__mobile__nav__link'));
    const oMenuPhone = [].slice.call(oMenu.querySelectorAll('.header__mobile__phone'));
    const aMenuTitles = [].slice.call(oMenu.querySelectorAll('.header__mobile__actions__item'));
    const aMenuLangSwitches = [].slice.call(oMenu.querySelectorAll('.lang-switch__item'));
    const aStaggerItems = aMenuItems.concat(oMenuPhone, aMenuTitles, aMenuLangSwitches);

    const aMenuItemsSubmenu = [].slice.call(oMenu.querySelectorAll('.js-mobile-submenu'));
    const aSubmenuCloseBtns = [].slice.call(oMenu.querySelectorAll('.js-mobile-submenu-close'));

    let activeSubmenuParentLi = null;
    let activeSubmenu = null;

    const oTimeline = new TimelineMax({
        paused: true
    }).to(oMenu, 0.8, {
        pointerEvents: 'all',
        autoAlpha: 1
    }).staggerTo(aStaggerItems, 1, {
        autoAlpha: 1,
        y: 0
    }, 0.08);

    TweenMax.defaultEase = Quart.easeIntOut;

    window.addEventListener('click', function (event) {
        if (event.target.closest('.js-menu-open')) {
            event.preventDefault();

            oTimeline.timeScale(4).play();
            document.body.classList.add('no-scroll');
        } else if (event.target.closest('.js-menu-close')) {
            event.preventDefault();

            oTimeline.timeScale(5.5).reverse();
            document.body.classList.remove('no-scroll');
        }
    });

    function openSubmenu(trigger) {
        const submenu = trigger.nextElementSibling;
        const parentLi = trigger.parentElement;

        parentLi.style.zIndex = 1;

        submenu.classList.add('is-open');

        activeSubmenu = submenu;
        activeSubmenuParentLi = parentLi;
    }

    function closeSubmenu(trigger) {
        activeSubmenu.classList.remove('is-open');

        setTimeout(() => {
            activeSubmenuParentLi.style.zIndex = 0;
            activeSubmenu = null;
            activeSubmenuParentLi = null;
        }, 250);
    }

    for (let i = 0; i < aMenuItemsSubmenu.length; i += 1) {
        aMenuItemsSubmenu[i].addEventListener('click', (e) => {
            e.preventDefault();
            openSubmenu(aMenuItemsSubmenu[i]);
        });
    }

    for (let i = 0; i < aSubmenuCloseBtns.length; i += 1) {
        aSubmenuCloseBtns[i].addEventListener('click', (e) => {
            closeSubmenu(aSubmenuCloseBtns[i]);
        });
    }
}